export default function addBrazilianCountryCode(phoneNumber?: string) {
  if (!phoneNumber) return undefined;

  return `+55${phoneNumber}`;
}
